import { HostSession } from '@typesApp/Environment'
import {
  AuthToken,
  CommerceCustomer,
  CommerceCustomerContext,
  Customer,
  CustomerContext,
  Session,
} from '@typesApp/Session'

export const createSessionWithToken = (sessionId: string, hostSession: HostSession, customer: Customer): Session => {
  const sanitizedCustomer = { ...customer, id: `${customer?.id ?? ''}` }
  return {
    customer: sanitizedCustomer,
    userId: sanitizedCustomer?.id,
    cartId: `${hostSession?.cartId ?? ''}`,
    sessionId: `${sessionId ?? ''}`,
    isGuest: hostSession?.isGuest,
    wcToken: hostSession?.wcToken,
    wcTrustedToken: hostSession?.wcTrustedToken,
  } as Session
}

export const createGuestSession = (
  sessionId: string,
  hostSession: HostSession,
  customer: Customer | undefined
): Session => {
  return {
    customer: {
      id: `${customer?.id ?? ''}`,
    },
    userId: `${customer?.id ?? ''}`,
    cartId: `${hostSession?.cartId ?? ''}`,
    sessionId: `${sessionId ?? ''}`,
    isGuest: hostSession?.isGuest,
  } as Session
}

export const toCustomer = (commerceCustomer: CommerceCustomer): Customer => {
  return {
    id: commerceCustomer.userId,
    legacyId: commerceCustomer?.attributes?.find(attr => attr.key === 'userField1')?.value ?? '',
    firstName: commerceCustomer?.firstName ?? '',
    lastName: commerceCustomer?.lastName ?? '',
    email: commerceCustomer?.email1 ?? '',
    phoneNumber: commerceCustomer?.phone1 ?? '',
  }
}

export const toCustomerContext = (commerceContext: CommerceCustomerContext): CustomerContext => {
  return {
    sessionId: `${commerceContext?.activityToken?.activityId ?? ''}`,
    isPartiallyAuthenticated: Boolean(commerceContext?.isPartiallyAuthenticated),
  }
}

/**
 * @returns decorated authToken with session information
 */
export const decorateToken = (token: AuthToken, sessionId: string): AuthToken => {
  return {
    ...token,
    sessionId,
  }
}
